import Analytics from "@/components/management/Analytics";
import BusinessInformation from "@/components/management/components/business/BusinessSettings";
import GoogleCalendarSettings from "@/components/management/components/integrations/GoogleCalendarSettings";
import AddEmployee from "@/components/management/components/menu/AddEmployee";
import EditEmployee from "@/components/management/components/menu/EditEmployee";
import Employee from "@/components/management/components/menu/Employee";
import ViewEmployeeTracking from "@/components/management/components/menu/ViewEmployeeTracking";
import Settings from "@/components/management/Setting";
import Support from "@/components/management/Support";

const SettingRoutes = [
  { path: "/employee", element: <Employee /> },
  { path: "/employee/add", element: <AddEmployee /> },
  { path: "/employee/edit/:id", element: <EditEmployee /> },
  { path: "/employee/:id", element: <ViewEmployeeTracking /> },
  { path: "/analytics", element: <Analytics /> },
  { path: "/information", element: <BusinessInformation /> },
  { path: "/support", element: <Support /> },
  { path: "/settings", element: <Settings /> },
  { path: "/integration/google-calendar", element: <GoogleCalendarSettings /> },
];

export default SettingRoutes;
